import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  loading: false,
  loaded: false,
  merchantKey: null,
  data: null,
  uploadSuccess: false,
  error: {},
})

const { Types, Creators } = createActions({
  getItemSync: ['merchantKey'],
  getItemSyncSuccess: ['itemSync'],
  getItemSyncError: ['error'],
  syncMerchantItems: ['merchantKey'],
  syncMerchantItemsSuccess: null,
  syncMerchantItemsError: ['error'],
  setLastUpdate: null,
})

export const syncMerchantItemsReducer = (state, { merchantKey }) =>
  state
    .set('loading', true)
    .set('loaded', false)
    .set('merchantKey', merchantKey)
export const syncMerchantItemsSuccessReducer = state =>
  state
    .set('loading', false)
    .set('loaded', true)
    .set('uploadSuccess', true)

export const syncMerchantItemsErrorReducer = (state, { error }) =>
  state
    .set('loading', false)
    .set('loaded', true)
    .set('uploadSuccess', false)
    .set('error', error)

export const getItemSyncReducer = (state, { merchantKey }) =>
  state.set('loading', true).set('merchantKey', merchantKey)

export const getItemSyncSuccessReducer = (state, { itemSync }) =>
  state
    .set('data', itemSync)
    .set('loading', false)
    .set('loaded', true)

export const getItemSyncErrorReducer = (state, { error }) =>
  state
    .set('loading', false)
    .set('loaded', true)
    .set('error', error)

export const setLastUpdateReducer = state => state

export const itemSyncReducer = createReducer(INITIAL_STATE, {
  [Types.GET_ITEM_SYNC]: getItemSyncReducer,
  [Types.GET_ITEM_SYNC_SUCCESS]: getItemSyncSuccessReducer,
  [Types.GET_ITEM_SYNC_ERROR]: getItemSyncErrorReducer,
  [Types.SYNC_MERCHANT_ITEMS]: syncMerchantItemsReducer,
  [Types.SYNC_MERCHANT_ITEMS_SUCCESS]: syncMerchantItemsSuccessReducer,
  [Types.SYNC_MERCHANT_ITEMS_ERROR]: syncMerchantItemsErrorReducer,
  [Types.SET_LAST_UPDATE]: setLastUpdateReducer,
})

export const ItemSyncTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/itemSyncReducer.js